<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" :cart_count="cart_count1" />
        <div style="width: 1200px; margin: 20px auto; overflow: hidden">
            <div style="overflow: hidden">
                <div style="width: 20%; height: 300px; float: left">
                    <div style="width: 100%; overflow: hidden; margin: 2% auto">
                        <div style="position: relative; height: 300px">
                            <!-- <div class="swiper-button-prev swiper-button-white" style="position: absolute; color: #dfdfdf; outline: none;z-index:999" @click="showGoodsCoverNext(-1)"></div>
                            <div class="swiper-button-next swiper-button-white" style="position: absolute; color: #dfdfdf; outline: none;z-index:999" @click="showGoodsCoverNext(1)"></div> -->

                            <div id="gallery" class="swiper-container" style="margin-bottom: 10px; height: 100%" v-if="imgs.length > 0">
                                <div class="swiper-wrapper" style="height: 100%">
                                    <div class="swiper-slide" style="border: 1px solid #ede9e9" v-for="(item, index) in goods_details.images" v-if="index == index1" :key="index">
                                        <img v-if="goodsCover" style="width: 100%; height: 100%" :src="goodsCover" />
                                        <img v-else src="../assets/pro-default-img@2x.png" alt="" style="width: 100%; height: 100%" />
                                    </div>
                                </div>
                            </div>
                            <img v-else src="../assets/pro-default-img@2x.png" alt="" style="width: 100%; height: 100%" />
                        </div>
                        <!-- 图片轮播 -->
                        <div class="item-swiper" id="thumbs" style="margin-left: 6px">
                            <swiper :options="swiperOption">
                                <swiper-slide v-for="(item, index) in imgs" :key="index" style="margin: 5px">
                                    <img style="width: 48px; height: 70px; cursor: pointer" :src="item" @click="showGoodsCover(index)" />
                                </swiper-slide>
                            </swiper>
                        </div>
                        <!-- 轮播 -->
                        <!-- <div id="thumbs" class="swiper-container" style="width: 70%; margin: 20px auto">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, index) in imgs" :key="index" style="border: 1px solid #ede9e9; width: 156px;margin-right: 12px;">
                                    <img style="width: 100%; height: 100%;cursor: pointer;" :src="item" @click="showGoodsCover(index)"/>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div style="overflow: hidden; margin: 20px auto; width: 70%">
                        <div style="cursor: pointer; float: left" @click="_favorites">
                            <img v-if="goods_details.favorites" src="../assets/shoucang_1.png" style="width: 15px; height: 15px; float: left; margin-top: 8px" alt="" />
                            <img v-else src="../assets/shoucang.png" style="width: 15px; height: 15px; float: left; margin-top: 8px" alt="" />
                            <span class="shoucamg_txt">{{ goods_details.favorites ? '已收藏' : '收藏' }}</span>
                        </div>
                        <div style="cursor: pointer; float: left; margin-left: 20px" hidden>
                            <img src="../assets/fenxiang1.png" style="width: 15px; height: 15px; float: left; margin-top: 8px" alt="" />
                            <span class="shoucamg_txt">分享</span>
                        </div>
                    </div>
                </div>

                <div style="width: 50%; float: left; padding: 0 1%; margin-left: 20px">
                    <div style="overflow: hidden">
                        <div class="gongchangziyin">{{ goods_details.storeName }}</div>
                        <div class="goods_title">{{ goods_details.name || '' }}</div>
                        <div v-if="goods_details.newProduct === true" class="newProduct">新品</div>
                        <!-- <div style="float: left; margin-left: 4%; margin-top: 10px">
                          <div class="goods_pinpai">品牌：科试</div>
                          <div class="goods_pinpai">编号：05.001.1755-</div>
                        </div> -->
                    </div>
                    <div style="width: 100%; height: 1px; background: #e8e8e8; margin-top: 2%"></div>
                    <div style="overflow: hidden; margin-top: 10px">
                        <div class="goods_guige_txt">CAS号：{{ goods_details.casNum || '' }}</div>
                        <div class="goods_guige_txt">分子量：{{ goods_details.molecularWeight || '' }}</div>
                    </div>
                    <div style="overflow: hidden; margin-top: 10px">
                        <div class="goods_guige_txt">分子式：{{ goods_details.molecularFormula }}</div>
                        <div class="goods_guige_txt">MDL号：{{ goods_details.mdlNum }}</div>
                    </div>
                    <div style="width: 100%; position: relative; margin-top: 20px; background: #f7f7f7">
                        <div style="width: 100%; height: 100%; left: 0; top: 0; overflow: hidden">
                            <div style="overflow: hidden; width: 96%; height: 100%; margin: 10px 10px 0 10px">
                                <div style="overflow: hidden">
                                    <template v-if="currentUserVipPrice">
                                        <div class="goods_guige1">
                                            <span style="color: #2c9a34"> {{ currentUserVipPrice.vipName }} </span>
                                            价格:
                                        </div>
                                        <div class="goods_prcie1" style="margin-top: -8px; margin-left: 10px; margin-right: 10px">
                                            ￥
                                            <span style="font-size: 24px">
                                                {{ (currentUserVipPrice ? currentUserVipPrice.price : currentSkuItem ? currentSkuItem.price : 0) / 100 }}
                                            </span>
                                        </div>
                                    </template>
                                    <div :style="currentUserVipPrice ? { textDecoration: 'line-through' } : null">
                                        普通用户
                                        <span>: ￥{{ price / 100 }}</span>
                                    </div>
                                </div>
                                <div style="overflow: hidden; margin-top: 10px;margin-bottom:10px">
                                    <div class="goods_guige1">促销:</div>
                                    <div class="goods_guige1" v-if="yhlist.length == 0">本产品不参与促销哦</div>
                                    <div style="width: 500px; margin-left: 30px; margin-top: 5px" v-else>
                                        <div v-for="(item, index) in yhlist" :key="index" style="width: 100%; height: 30px">
                                            <div class="cuxiao_box" style="margin-left: 10px">
                                                满
                                                {{ Math.floor(item.conditionsAmount / 100) }}
                                                减
                                                {{ Math.floor(item.creditAmount / 100) }}
                                            </div>
                                            <div class="goods_guige1" style="font-size: 12px; margin-left: 10px">
                                                {{ item.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 10px">
                        <div style="overflow: hidden">
                            <div class="fahou_base_txt">发货仓</div>
                            <div v-if="goods_details.warehouseList">
                                <a-select placeholder="选择发货仓" style="width: 150px; float: left; margin-left: 2%" @change="_skuConditionChangeFun" :defaultValue="goods_details.warehouseList[0].warehouseId">
                                    <a-select-option v-for="(item, index) in goods_details.warehouseList" :key="index" :value="item.warehouseId">{{ item.warehouseName }}</a-select-option>
                                </a-select>
                            </div>
                            <!-- <div>单位：</div> -->
                            <div class="fahou_base_txt" style="margin-left: 35%">单位：</div>
                            <div class="fahou_base_txt" v-if="currentSkuItem">{{ currentSkuItem.unit }}</div>
                            <!-- <div class="fahou_base_txt" style="margin-left: 4%">配送至</div>
                            <a-select @change="peisong_chang" default-value="选择配送地址" style="width: 150px; float: left; margin-left: 2%" :defaultValue="address_list.province + '/' + address_list.city + '/' + address_list.area ? undefined : null">
                                <a-select-option v-for="(item, index) in address_list" :key="index" :value="item.province + '/' + item.city + '/' + item.area">{{ item.province + '/' + item.city + '/' + item.area }}</a-select-option>
                            </a-select> -->

                            <div class="fahou_base_txt" style="float: right;color:#2c9a34" v-if="currentSkuItem">
                                库存数：
                                <span style="color: #2c9a34">
                                    {{ currentSkuItem.stock || 0 }}
                                </span>
                            </div>
                        </div>

                        <div style="margin-top: 10px" class="peisong_tips">
                            <template v-if="currentSkuRow">
                                由<span style="color: #2c9a34">{{ currentSkuRow.warehouseName }}</span
                                >发货，
                            </template>
                            <span style="color: #2c9a34">{{ goods_details.storeName }}</span
                            >提供售后服务
                            <span v-if="currentSkuItem">货期：{{ currentSkuItem.stock ? '现货' : '期货' }}</span>
                        </div>

                        <div class="sku-list-warp">
                            <ul>
                                <li :class="['sku-list-warp__content', currentSkuItem && item.uuid === currentSkuItem.uuid ? 'active' : null]" :title="_getSkuNamesFun(item)" @click="_productSkuClick(item, item.price)" v-for="(item, index) in currentSkuList" :key="index">{{ _getSkuNamesFun(item) }}</li>
                            </ul>
                        </div>

                        <div class="tips_bottom">
                            * 销售单位-最小起订量 :
                            {{ currentSkuItem ? currentSkuItem.minQuantity || 1 : 1 }}
                            <!-- <template v-if="currentSkuItem"> / {{ currentSkuItem.unit }} </template> -->
                        </div>

                        <div style="width: 100%; height: 1px; background: #e8e8e8; margin-top: 2%"></div>

                        <div style="overflow: hidden; margin-top: 20px">
                            <div class="number_box">
                                <input style="border: 1px solid #dcdcdc; width: 40px; height: 50px; float: left; text-align: center; outline: none" :min="1" v-model="shuliang" name="" id="" />
                                <div style="width: 25px; height: 51px; float: left">
                                    <div @click="jiaShuliang" style="cursor: pointer; text-align: center; line-height: 25px; border-top: 1px solid #dcdcdc; border-right: 1px solid #dcdcdc">+</div>
                                    <div @click="jianShuliang" style="cursor: pointer; text-align: center; line-height: 23px; border-bottom: 1px solid #dcdcdc; border-right: 1px solid #dcdcdc">-</div>
                                </div>
                            </div>
                            <!-- @click="lijiqiangguo" -->
                            <div :class="['pay_buts1', is_disable ? 'disable_but' : '']" @click="yujiesuan">
                                <a-tooltip :hidden="is_available">
                                    <template slot="title">非常抱歉，您无此产品购买资质，请确认贵公司《危险化学品经营许可证》目录有无此产品。如有，请上传相关资质，点击红色感叹号上传</template>
                                    <img src="../assets/notice.png" @click="toQualifications" />
                                </a-tooltip>
                                立即抢购
                            </div>
                            <div :class="['pay_buts', is_disable ? 'disable_but' : '']" @click="add_cart">
                                <a-tooltip :hidden="is_available">
                                    <template slot="title">非常抱歉，您无此产品购买资质，请确认贵公司《危险化学品经营许可证》目录有无此产品。如有，请上传相关资质，点击红色感叹号上传</template>
                                    <img src="../assets/notice.png" @click="toQualifications" />
                                </a-tooltip>
                                加入购物车
                            </div>
                            <div class="pay_buts btn-customer" @click="handleJump">联系客服</div>
                        </div>
                        <!-- <a-button @click="yujiesuan">预结算</a-button> -->
                        <div class="zhifufangshi" style="margin-top: 20px; overflow: hidden">
                            <div style="float: left">支付方式</div>
                            <div style="overflow: hidden; margin-left: 20px; float: left">
                                <img src="../assets/zhifufangshi1.png" style="float: left; width: 14px; height: 14px; float: left; margin-top: 2px" alt="" />
                                <span style="margin-left: 5px; float: left">线下转账</span>
                            </div>
                            <div style="overflow: hidden; margin-left: 20px; float: left">
                                <img src="../assets/zhifufangshi1.png" style="float: left; width: 14px; height: 14px; float: left; margin-top: 2px" alt="" />
                                <span style="margin-left: 5px; float: left">在线支付</span>
                            </div>
                        </div>

                        <div class="zhifufangshi" style="margin-top: 20px; overflow: hidden">
                            <div style="float: left">发票方式</div>
                            <div style="overflow: hidden; margin-left: 20px; float: left">
                                <img src="../assets/zengzhishui1.png" style="float: left; width: 14px; height: 14px; float: left; margin-top: 2px" alt="" />
                                <span style="margin-left: 5px; float: left">增税普票</span>
                            </div>
                            <div style="overflow: hidden; margin-left: 20px; float: left">
                                <img src="../assets/zengzhishui1.png" style="float: left; width: 14px; height: 14px; float: left; margin-top: 2px" alt="" />
                                <span style="margin-left: 5px; float: left">增税专票</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 300px; height: 300px; float: left; margin-left: 20px">
                    <swiperRight />
                </div>
            </div>

            <div style="width: 100%; height: 140px; margin-top: 60px">
                <img src="../assets/goods_detailks_img.png" style="width: 100%; height: 100%" alt="" />
            </div>

            <div></div>

            <div style="overflow: hidden; margin-top: 2%">
                <div style="float: left; width: 20%; height: 100%; border: 1px solid #ececec; padding: 10px">
                    <div style="overflow: hidden">
                        <div class="fengexian" style="margin-top: 5px"></div>
                        <div class="tuijian_top_txt" style="margin-left: 2%">推荐商品</div>
                        <div style="overflow: hidden; float: right">
                            <div @click="_huanyipi" class="huanyipi" style="margin-right: 5px">换一批</div>
                            <img src="../assets/gegnhaun icon@2x.png" style="float: left; width: 11px; height: 11px; margin-top: 5px" alt="" />
                        </div>
                    </div>

                    <div @click="to_goods_details(item)" class="left_goods_box" v-for="(item, index) in hot_goods" :key="index">
                        <div style="width: 100%; height: 228px; position: relative">
                            <img v-if="item.cover" :src="'/api/file/preview/' + item.cover" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0" alt="" />
                            <img v-else src="../assets/pro-default-img@2x.png" alt="" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0" />

                            <div class="goods_tag" style="position: relative">
                                <img src="../assets/gouwuche_tag.png" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0" alt="" />
                                <div style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: 9999">热销</div>
                            </div>
                        </div>
                        <div style="overflow: hidden; padding: 2%">
                            <div style="overflow: hidden; margin-top: 2%">
                                <a-row>
                                    <a-col :span="12" class="left_goods_item_txt1">{{ item.name }}</a-col>
                                    <a-col :span="12" class="left_goods_item_txt1">品牌：{{ item.brand }}</a-col>
                                </a-row>
                            </div>
                            <div style="overflow: hidden; margin-top: 2%">
                                <a-row>
                                    <a-col :span="12" class="left_goods_item_txt1" style="color: #666; font-size: 12px">别名：{{ item.alias }}</a-col>
                                    <a-col :span="12" class="left_goods_item_txt1" style="color: #666; font-size: 12px">Beilstein号：{{ item.beilsteinNum }}</a-col>
                                </a-row>
                            </div>
                            <div style="overflow: hidden; margin-top: 2%">
                                <a-row>
                                    <a-col :span="12" class="left_goods_item_txt1" style="color: #666; font-size: 12px">沸点：{{ item.boilingPoint }}</a-col>
                                    <a-col :span="12" class="left_goods_item_txt1" style="color: #666; font-size: 12px">密度：{{ item.density }}</a-col>
                                </a-row>
                            </div>
                            <div style="overflow: hidden; margin-top: 2%">
                                <a-row>
                                    <a-col :span="12" class="left_goods_item_txt1" style="color: #666; font-size: 12px">CAS号：{{ item.casNum }}</a-col>
                                    <a-col :span="12" class="left_goods_item_txt1" style="color: #666; font-size: 12px"></a-col>
                                </a-row>
                            </div>

                            <div style="overflow: hidden; margin-top: 10px">
                                <div class="manjian" v-if="item.promotion">优惠满减</div>
                                <div @click.stop="shoucang_left(item)" style="cursor: pointer">
                                    <img v-if="item.favorites" src="../assets/shoucang_1.png" style="width: 16px; float: right; height: 16px" alt="" />
                                    <img v-else src="../assets/shoucang.png" style="width: 16px; float: right; height: 16px" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 78%; float: left; margin-left: 2%">
                    <div class="right_box_top_box">
                        <div @click="_dibuqiehuan(index)" v-for="(item, index) in dibuqiehuan" :key="index" :class="['right_box_top_box_item', dibuqiehuan_index === index ? 'dibuqiehuan_sty' : '']">
                            <a :class="['right_box_top_box_item', dibuqiehuan_index == index ? 'dibuqiehuan_sty' : '']">{{ item.txt }}</a>
                        </div>
                        <div class="bootom_add_cart" @click="add_cart">加入购物车</div>
                    </div>
                    <!-- "产品详情" -->
                    <div v-if="dibuqiehuan_index == 0">
                        <div style="margin-top: 20px; overflow: hidden">
                            <div class="chanpinjieshao">产品介绍</div>
                            <div class="chanpinjieshao" style="font-size: 14px; margin-left: 10px; width: 90%">
                                {{ goods_details.introduction }}
                            </div>
                        </div>
                        <div style="margin: 20px 0; overflow: hidden; border-top: 1px solid #ede9e9">
                            <!-- <div class="goods_table_base_txt" style="margin-bottom:5px">
                                <a-row style="border-bottom: 1px solid #ede9e9;margin-bottom:5px" v-if="goods_details.alias" >
                                    <a-col :span="4" class="goods_table_base_left">中文别名</a-col>
                                    <a-col :span="18" class="biange12">{{goods_details.alias}}</a-col>
                                </a-row>
                                <a-row style="border-top: 1px solid #ede9e9" v-if="goods_details.englishName">
                                    <a-col :span="4" class="goods_table_base_left">英文正名/别名</a-col>
                                    <a-col :span="18" class="biange12">{{goods_details.englishName}}</a-col>
                                </a-row>
                        </div> -->
                            <a-row class="form-row" :gutter="24">
                                <a-col :lg="24" :md="12" :sm="24" v-if="goods_details.alias">
                                    <a-form-item>
                                        <div class="goods_table_base_left1">中文别名</div>
                                        <span class="ziti1">
                                            {{ goods_details.alias }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="24" :md="12" :sm="24" v-if="goods_details.englishName">
                                    <a-form-item>
                                        <div class="goods_table_base_left1">英文正名/别名</div>
                                        <span class="ziti1">
                                            {{ goods_details.englishName }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.molecularFormula">
                                    <a-form-item>
                                        <div class="goods_table_base_left1">分子式</div>
                                        <span class="ziti">
                                            {{ goods_details.molecularFormula }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">商品编号</span>
                                        <span class="ziti">
                                            {{ goods_details.sn }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.molecularWeight">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">分子量</span>
                                        <span class="ziti">
                                            {{ goods_details.molecularWeight }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.storageCondition">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">存储条件</span>
                                        <span class="ziti">
                                            {{ goods_details.storageCondition }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.casNum">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">CAS号</span>
                                        <span class="ziti">
                                            {{ goods_details.casNum }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.harmfulCode">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">危害码（欧洲）</span>
                                        <span class="ziti">
                                            {{ goods_details.harmfulCode }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.unNum">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">UN号</span>
                                        <span class="ziti">
                                            {{ goods_details.unNum }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.riskNature">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">危险性质</span>
                                        <span class="ziti">
                                            {{ goods_details.riskNature }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.riskStatement">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">风险声明</span>
                                        <span class="ziti">
                                            {{ goods_details.riskStatement }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.ghsIcon">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">GHS图标</span>
                                        <span class="ziti">
                                            <img v-if="goods_details.ghsIcon" :src="'/api/file/preview/' + goods_details.ghsIcon" style="width: 41px; height: 41px" alt="" />
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.purpose">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">应用</span>
                                        <a-popover>
                                            <template slot="content">
                                                <span class="">
                                                    {{ goods_details.purpose }}
                                                </span>
                                            </template>
                                            <span class="ziti">
                                                {{ goods_details.purpose }}
                                            </span>
                                        </a-popover>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.mdlNum">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">MDL号</span>
                                        <span class="ziti">
                                            {{ goods_details.mdlNum }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.meltingPoint">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">熔点</span>
                                        <span class="ziti">
                                            {{ goods_details.meltingPoint }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="currentSkuItem ? currentSkuItem.deliveryTime : ''">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">交期</span>
                                        <span class="ziti">
                                            {{ currentSkuItem ? currentSkuItem.deliveryTime : '' }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.density">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">密度</span>
                                        <span class="ziti">
                                            {{ goods_details.density }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.flashPoint">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">闪点</span>
                                        <span class="ziti">
                                            {{ goods_details.flashPoint }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.waterSolubility">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">水溶解性</span>
                                        <span class="ziti">
                                            {{ goods_details.waterSolubility }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.f129">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">材质</span>
                                        <span class="ziti">
                                            {{ goods_details.f129 }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.f130">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">颜色</span>
                                        <span class="ziti">
                                            {{ goods_details.f130 }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                                <a-col :lg="12" :md="12" :sm="24" v-if="goods_details.f131">
                                    <a-form-item>
                                        <span class="goods_table_base_left1">特点</span>
                                        <span class="ziti">
                                            {{ goods_details.f131 }}
                                        </span>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <!-- <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">分子式</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.molecularFormula }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">商品编号</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.sn }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">分子量</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.molecularWeight }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">存储条件</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.storageCondition }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">CAS号</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.casNum }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">危害码（欧洲）</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.harmfulCode }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                     <a-col :span="4" class="goods_table_base_left">UN号</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.unNum }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">安全声明</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.securityStatement }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                   <a-col :span="4" class="goods_table_base_left">危险性质</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.riskNature }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">风险声明</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.riskStatement }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">GHS图标</a-col>
                                    <a-col :span="8" class="biange12">
                                        <img v-if="goods_details.ghsIcon" :src="'/api/file/preview/' + goods_details.ghsIcon" style="width: 41px; height: 41px;" alt="" />
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">应用</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.purpose }}
                                    </a-col>
                                </a-row> -->
                            <!-- <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">MDL号</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.mdlNum }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">熔点</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.meltingPoint }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">交期</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ currentSkuItem?currentSkuItem.deliveryTime:'' }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">密度</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.density }}
                                    </a-col>
                                </a-row>
                                <a-row style="border-bottom: 1px solid #ede9e9">
                                    <a-col :span="4" class="goods_table_base_left">闪点</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.flashPoint }}
                                    </a-col>
                                    <a-col :span="4" class="goods_table_base_left">水溶解性</a-col>
                                    <a-col :span="8" class="biange12">
                                        {{ goods_details.waterSolubility }}
                                    </a-col>
                                </a-row> -->
                        </div>
                        <div v-html="goods_details.content" class="img" style="padding-top: -20px"></div>
                    </div>
                    <!-- "售后保障" -->
                    <div style="" v-if="dibuqiehuan_index == 1">
                        <div class="guige_title">
                            <p v-html="goods_details.afterSale"></p>
                        </div>
                    </div>
                    <!-- "MSDS文档" -->
                    <div v-if="dibuqiehuan_index == 2">
                        <div v-if="goods_details.msdsFile">
                            <div class="guige_titles">
                                <div>{{ goods_details.msdsFile.fileName }}</div>
                                <div>
                                    <a style="color: #2b9a34" :href="'/api/file/download/' + goods_details.msdsFile.fileId" target="_blank">下载</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- "COA查询" -->
                    <div v-if="dibuqiehuan_index == 3">
                        <a-input-search placeholder="请输入批号" enter-button="查询" size="large" @search="onSearch" style="border-color: #2b9a34; width: 400px; margin-top: 20px" />
                        <template>
                            <div class="xiazai_buts">
                                <a-table bordered :data-source="coa_data" :columns="columns" :showHeader="false">
                                    <template slot="batch" slot-scope="text, record"> 批号：{{ record.batch }} </template>
                                    <template slot="operation" slot-scope="text, record">
                                        <div class="xiazai_butss">
                                            <a style="color: #2b9a34" :href="'/api/file/download/' + record.fileId" target="_blank">下载</a>
                                        </div>
                                    </template>
                                </a-table>
                            </div>
                        </template>
                        <!-- <div v-if="coa_data" v-for="(item, index) in coa_data" :Key="index">
                            <div class="guige_title">{{ item.fileName }}</div>
                            <div class="xiazai_but">
                                <a style="color: #2b9a34" :href="'/api/file/download/' + item.fileId" target="_blank">下载</a>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
// import testSwiper from '../public/swiper'

import foot from '../public/foot';
import swiperRight from '../public/swiper_right';
let websocket = null;
export default {
    name: 'GoodsDetail',
    components: {
        userLeft,
        htmlHeader,
        foot,
        swiperRight
        // testSwiper
    },
    data() {
        return {
            swiperOption: {
                autoplay: true,
                slidesPerView: 3,
                spaceBetween: 30,
                freeMode: true
            },
            userId: '',
            price: null,
            currentUserVipPrice: null,
            currentSkuRow: null,
            // 当前选择的规则列表
            currentSkuList: [],
            // 当前选择的规格
            currentSkuItem: null,
            cart_count1: 20,
            coa_data: null, //coa查询的数据
            dibuqiehuan: [
                // "产品详情", "售后保障", "MSDS文档", "COA查询"
                {
                    txt: '产品详情',
                    id: 'cpxq'
                },
                {
                    txt: '售后保障',
                    id: 'shbz'
                },
                {
                    txt: 'MSDS文档',
                    id: 'msdswd'
                },
                {
                    txt: 'COA查询',
                    id: 'coacx'
                }
            ], //详情标题切换
            dibuqiehuan_index: 0, //详情标题切换索引
            is_disable: true, //不能买
            address_list: [], //我的地址
            baozhuang_index: 0, //包装选中
            guige_index: 0, //规格选中
            shuliang: 1,
            goods_details: '', //商品详情
            hot_goods: [], //热销
            tuijian_page: 0,
            yhlist: [],
            index1: 0,
            imgs: [],
            imgs_index: 0,
            is_available: true,
            kucun: null,
            columns: [
                {
                    title: 'name',
                    dataIndex: 'batch',
                    scopedSlots: { customRender: 'batch' },
                    width: '30%'
                },
                {
                    title: 'age',
                    dataIndex: 'fileName',
                    scopedSlots: { customRender: 'fileName' }
                },
                {
                    title: 'operation',
                    scopedSlots: { customRender: 'operation' }
                }
            ]
        };
    },
    created() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.get_goods_details();
        this.get_my_address();
        this.get_hot_goods(this.tuijian_page);
        this.userId = JSON.parse(localStorage.getItem('user_info'));
    },
    watch: {
        shuliang(newName, oldName) {
            console.log(newName);
            if (newName * 1 < 1) {
                this.shuliang = 1;
            }
        }
    },
    computed: {
        // 商品封面
        goodsCover() {
            let url = '';
            if (this.imgs.length) {
                url = this.imgs[this.imgs_index];
            }
            return url;
        },
        skuNameStr() {
            let str = '';
            if (this.currentSkuItem) {
                const item = this.currentSkuItem;
                str = `${item.skuSn}-${item.brandName}-${item.packaging}-${item.specification}`;
            }
            return str;
        }
    },
    methods: {
        handleJump() {
            let storeId = this.goods_details.storeId;
            if (this.userId !== null) {
                this.api.isOpen(storeId).then(res => {
                    if (res.ok == true) {
                        if (window.localStorage.user_info) {
                            window.open(`/cus/#/client?storeId=${this.goods_details.storeId}&entranceId=75b1dd5d-cea2-4042-bdb8-ce74a9eceaf2&userId=${this.userId.uuid}&goodsId=${this.goods_details.uuid}`);
                            let list = {
                                storeId: this.goods_details.storeId,
                                userId: this.userId.uuid
                            };
                            this.api.tiaozhuan(list).then(res => {});
                        }
                        // }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        // WebSocket () {
        //    //判断浏览器是否支持websocket
        //     if ('WebSocket' in window) {
        //       websocket = new WebSocket("ws://139.9.158.188:10031/api/public/connect/9527");
        //     } else {
        //       alert('Not support websocket')
        //     }
        //      //连接成功建立的回调方法
        //     websocket.onopen = function (event) {
        //       console.log('open');
        //        send()
        //     }
        //     //消息实体
        //     var sendMessageJson = {
        //       storeId: this.goods_details.storeId,
        //       entranceId: '75b1dd5d-cea2-4042-bdb8-ce74a9eceaf2',
        //       userId: this.userId.uuid,
        //       context: "",
        //       receiveId: "",
        //       messageType: "",
        //       readType: '',
        //       newstype: '',
        //       entranceId: '',
        //       product: '',
        //       orders: '',
        //       backupsinfo: '',
        //       sendDate: ''
        //     }
        //     //发送消息
        //     function send() {
        //       // var message = document.getElementById('text').value;
        //       // sendMessageJson.context = message
        //       websocket.send(JSON.stringify(sendMessageJson),(res)=>{
        //         console.log('成功=============》')
        //       });
        //       console.log('发送消息')
        //       // closeWebSocket()
        //     }

        //     //接收到消息的回调方法
        //     websocket.onmessage = function (event) {
        //       console.log('ok')
        //     }
        //     //连接发生错误的回调方法
        //     websocket.onerror = function () {
        //       setMessageInnerHTML("error");
        //     };

        //     //连接关闭的回调方法
        //     websocket.onclose = function () {
        //       setMessageInnerHTML("close");
        //     }

        //     //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        //     window.onbeforeunload = function () {
        //       websocket.close();
        //     }

        //     //将消息显示在网页上
        //     function setMessageInnerHTML(innerHTML) {
        //       console.log('======',innerHTML)
        //       console.log('将消息显示在网页上')
        //     }

        //     //关闭连接
        //     function closeWebSocket() {
        //       websocket.close();
        //       console.log('关闭连接')
        //     }
        //   },
        checkLogin() {
            if (window.localStorage.uuid) {
                return true;
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
                return false;
            }
        },
        checkAvailable(num) {
            if (!window.localStorage.uuid) return;
            if (!this.goods_details.userAvailable) {
                this.is_available = false;
            }
            // this.api.get_cas_num(num)
            //     .then(res => {
            //         if (!res.data)
            //             this.is_available = false
            //     })
        },
        toQualifications() {
            if (window.localStorage.user_info) {
                this.$router.push('/qualifications');
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        add() {
            alert(111);
            // var that = this
            // var index1 = that.index1
            // that.index1 = index1+1
            // console.log(this.index1)
        },
        // 显示-商品封面
        showGoodsCover(index) {
            this.imgs_index = index;
        },
        showGoodsCoverNext(flag) {
            let index = this.imgs_index + flag;
            if (index < 0) return;
            if (index >= this.imgs.length) return;
            this.imgs_index = index;
        },
        // 拼接规格名
        _getSkuNamesFun(item) {
            let str = [];
            if (item.skuSn) str.push(item.skuSn);
            if (item.brandName) str.push(item.brandName);
            // if (item.packaging) str.push(item.packaging);
            if (item.specification) str.push(item.specification);
            return str.join('-');
        },
        // coa查询
        onSearch(e) {
            this.api
                .get_productFile_coaSearch({
                    productId: this.goods_details.uuid,
                    skuSn: e,
                    storeId: this.goods_details.storeId
                })
                .then(res => {
                    this.coa_data = res.data;
                });
        },
        // 获取推荐换一批随机页码 1-10
        getRandomNumberByRange(start, end) {
            return Math.floor(Math.random() * (end - start) + start);
        },
        // 换一批
        _huanyipi() {
            this.tuijian_page = this.getRandomNumberByRange(0, 10);
            this.get_hot_goods(this.tuijian_page);
        },
        // 去商品详情页
        to_goods_details(e) {
            this.$router.push(`/goods_details?uuid=${e.uuid}&storeId=${e.storeId}`);
            this.get_goods_details();
            let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
            scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
            this.toTop();
        },
        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            // 实现滚动效果
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 0) {
                    clearInterval(timeTop);
                }
            }, 10);
        },
        // 收藏热销商品
        shoucang_left(e) {
            if (e.favorites) {
                this.api.dange_cancel_favorites(e.uuid).then(res => {
                    if (res.ok) {
                        this.get_hot_goods(this.tuijian_page);
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.api.add_favorites(e.uuid).then(res => {
                    if (res.ok) {
                        this.get_hot_goods(this.tuijian_page);
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        // 获取热销
        get_hot_goods(page) {
            this.api.get_hot_goods(page).then(res => {
                this.hot_goods = res.data.content;
            });
        },
        // 底部标题切换
        _dibuqiehuan(e) {
            this.dibuqiehuan_index = e;
            if (e == 3) {
                this.onSearch();
            }
        },
        // 直接购买
        lijiqiangguo() {
            if (!this.checkLogin()) return;
            if (this.is_disable) {
                return false;
            }
            // 如果没有casNum可以直接购买
            if (this.goods_details.casNum) {
                this._getCasNumFun().then(() => {
                    this._buyPostFun();
                });
                return false;
            }
            this._buyPostFun();
        },
        // 立即购买，发送请求
        _buyPostFun() {
            this.goods_details.skuList = this.currentSkuItem;
            let cart_goods_list = [
                {
                    quantity: this.shuliang,
                    storeInfo: {
                        name: this.goods_details.storeName
                    },
                    list: [this.goods_details],
                    active_list: [this.goods_details],
                    active: true
                }
            ];
            localStorage.cart_goods_list = JSON.stringify(cart_goods_list);
            this.$router.push('/direct_place_order');
        },
        // 改变收藏状态
        _favorites() {
            if (!this.checkLogin()) return;
            if (this.goods_details.favorites) {
                this.api.dange_cancel_favorites(this.goods_details.uuid).then(res => {
                    if (res.ok) {
                        this.get_goods_details();
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.api.add_favorites(this.goods_details.uuid).then(res => {
                    if (res.ok) {
                        this.get_goods_details();
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        _skuConditionChangeFun(id) {
            if (!id) {
                id = this.goods_details.warehouseList[0].warehouseId;
            }
            let row = this.goods_details.warehouseList.find(item => item.warehouseId === id);
            // 当前选择的发货仓库
            this.currentSkuRow = row;
            this.currentSkuList = row.skuList;
            this.$nextTick(() => {
                this.currentSkuItem = this.currentSkuList[0];
            });
        },
        // 加入购物车
        add_cart() {
            const NumberReg = /^\d{1,}$/;
            if (!NumberReg.test(this.shuliang)) {
                this.$message.error(`请输入有效数字`);
                return;
            }
            if (!this.checkLogin()) return;
            if (this.is_disable) {
                return false;
            }
            // 如果没有casNum可以直接购买
            if (this.goods_details.casNum) {
                this._getCasNumFun().then(() => {
                    this._addCartPostFun();
                });
                return false;
            }
            this._addCartPostFun();
        },
        // 预结算页面提交
        yujiesuan() {
            if (!this.checkLogin()) return;

            const NumberReg = /^\d{1,}$/;
            if (!NumberReg.test(this.shuliang)) {
                this.$message.error(`请输入有效数字`);
                return;
            } else if (this.shuliang > this.kucun) {
                this.$message.error(`输入有误, 当前库存${this.kucun}`);
                return;
            } else if (!this.goods_details.userAvailable) {
                that.$router.push('/qualifications');
                return;
            } else if (window.localStorage.user_info) {
                let uuid = this.currentSkuItem.uuid;
                let cart_goods_list = [
                    {
                        number: this.shuliang,
                        uuid: uuid,
                        buyType: 0
                    }
                ];
                localStorage.cart_goods_list = JSON.stringify(cart_goods_list);
                this.$router.push('/budgetandsettlement');
            } else if (!window.localStorage.user_info) {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
            // else {
            //   this.$router.push('/budgetandsettlement');
            // }
        },
        // 获取是否有资质
        _getCasNumFun() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (this.goods_details.userAvailable) {
                    resolve();
                } else {
                    this.$confirm({
                        title: '请先上传资质',
                        onOk() {
                            that.$router.push('/qualifications');
                        }
                    });
                }
                // this.api.get_cas_num(this.goods_details.casNum).then(res => {
                //     if (res.data) {
                //         resolve();
                //     } else {

                //     }
                // });
            });
        },
        // 发送请求加入购物车，并刷新购物车数量
        _addCartPostFun() {
            if (this.shuliang > this.kucun) {
                this.$message.error(`输入有误, 当前库存${this.kucun}`);
            } else {
                this.api
                    .add_cart({
                        productSkuId: this.currentSkuItem.uuid,
                        quantity: this.shuliang
                    })
                    .then(res => {
                        if (res.ok) {
                            this.$message.success('操作成功');
                            // 刷新购物车
                            this.$store.commit('updateCartCount');
                            // window.location.reload()
                        } else {
                            this.$message.error(res.message);
                        }
                    });
            }
        },
        // 数量加减
        jianShuliang() {
            if (this.currentSkuItem.minQuantity == null) {
                this.currentSkuItem.minQuantity = 1;
            }
            if (this.shuliang > this.currentSkuItem.minQuantity) {
                this.shuliang--;
            } else {
                this.$message.error('不能再少了');
            }
        },
        jiaShuliang() {
            this.shuliang++;
        },
        // 获取商品详情
        get_goods_details() {
            this.api.get_goods_details(this.$route.query.uuid, this.$route.query.storeId).then(res => {
                this.goods_details = res.data;
                // if (res.data.status == 2) {
                //     this.$router.push('/login');
                // } else if (res.data.status == 0) {
                //     this.$router.push({
                //         name: 'register'
                //     });
                // } else {
                // console.log(res.data, '----------------------------')
                this._skuConditionChangeFun();
                this.checkAvailable();
                console.log(this.goods_details);
                this.get_my_ss({ productId: res.data.uuid });
                this.checkAvailable(res.data.casNum);
                this._productSkuClick();
                this.price = res.data.warehouseList[0].skuList[0].price;
                this.currentUserVipPrice = res.data.warehouseList[0].skuList[0].currentUserVipPrice;
                this.kucun = res.data.warehouseList[0].skuList[0].stock;
                // 图片
                const imgs = [];
                if (res.data.images) {
                    res.data.images.forEach(i => {
                        imgs.push(`/api/file/preview/${i}`);
                    });
                }
                this.imgs = imgs;
                // }
            });
        },
        // 切换了规格重新请求数据
        _productSkuClick(item, price) {
            console.log(price, '1');
            this.price = price;
            if (this.is_available) {
                console.log(price, '2');
                this.is_disable = false;
            }
            if (item) {
                console.log(price, '3');

                this.currentUserVipPrice = item.currentUserVipPrice;
                this.currentSkuItem = item;
                this.kucun = item.stock;
                this.shuliang = item.minQuantity || 1;
            }
        },
        // 我的地址列表
        get_my_address() {
            if (!window.localStorage.uuid) return;
            this.api.get_address().then(res => {
                this.address_list = res.data;
            });
        },
        // 切换配送地址
        peisong_chang() {},
        get_my_ss(id) {
            this.api.get_promotionList(id).then(res => {
                this.yhlist = res.data;
            });
        }
    }
};
</script>

<style scoped>
/deep/.ant-form-item {
    margin-bottom: 5px;
    border: 1px solid rgb(237, 233, 233);
}
.newProduct {
    font-size: 13px;
    height: 24px;
    line-height: 26px;
    width: 50px;
    border-radius: 12px 12px 12px 0px;
    margin-left: 10px;
    color: #fff;
    display: inline-block;
    text-align: center;
    background: #f24145;
    margin-top: 5px;
}
/deep/.img p img {
    display: inline-block;
    height: auto;
    max-width: 100%;
}
/deep/.img {
    padding: 0px;
}
.swiper-slide img {
    object-fit: cover;
}
.pay_buts img,
.pay_buts1 img {
    position: absolute;
    right: 0;
    cursor: pointer;
}
.btn-customer {
    text-indent: 38px;
    background: url(../assets/customer.png) no-repeat 25px 15px;
}

.sku-list-warp {
    margin-top: 10px;
}
.sku-list-warp > ul {
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
}
.sku-list-warp__content {
    display: block;
    margin: 0 6px 12px 0;
    list-style: none;
    line-height: 24px;
    padding: 4px 8px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #ede9e9;
    cursor: pointer;
}
.sku-list-warp__content.active,
.sku-list-warp__content:hover {
    border: 1px solid #2b9a34;
    color: #2b9a34;
}

.goods_tag {
    width: 50px;
    height: 24px;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fefefe;
}

.shoucamg_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    float: left;
    margin-left: 10px;
}

.swiper-button-next,
.swiper-button-prev {
    top: 120% !important;
}

#thumbs {
    margin-top: 10px;
}

.row {
    padding: 0;
    margin: 0;
}

.col-md-4 {
    padding: 0;
}

.swiper-button-prev:after,
.swiper-button-next:after {
    font-size: 25px !important;
}

#thumbs .swiper-slide {
    /* line-height: 90px!important; */
    /* opacity: 0.4; */
    width: 50px !important;
    height: 70px !important;
}

#thumbs .swiper-slide-thumb-active {
    /* opacity: 1; */
    border: 1px solid #2b9a34 !important;
}

.xiazai_but {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-top: 20px;
    cursor: pointer;
}
.xiazai_buts {
    margin-top: 20px;
}
.xiazai_butss {
    text-align: center;
}
.xiazai_butsss {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    cursor: pointer;
}
.guige_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-top: 20px;
}
.guige_titles {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-top: 20px;
    display: flex;
    align-items: center;
    width: 60%;
}
.guige_titles > div {
    padding: 15px 100px;
    border: 1px solid #e8e8e8;
}
.goods_table_base_left {
    text-align: center;
    line-height: 50px;
    background: #f4f4f4;
}
.goods_table_base_left1 {
    width: 156px;
    height: 50px;
    line-height: 50px;
    display: inline-block;
    background-color: #f4f4f4;
    text-align: center;
    margin-right: 8px;
}
.ziti {
    width: 290px;
    display: inline-block;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: right;
    margin-top: 5px;
}
.ziti1 {
    width: 290px;
    /* display: inline-block; */
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* margin-top:5px; */
}
/* .goods_table_base_left2 {
    width: 290px;
    display: inline-block;
    line-height: 12px;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.goods_table_base_left2:hover{
      overflow: visible;
      animation: 4s siderbar linear infinite normal;
      z-index: 0;
  } */
@keyframes siderbar {
    0% {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }
    100% {
        transform: translateX(-500px);
        -webkit-transform: translateX(-500px);
    }
}
.goods_table_base_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    border-bottom: 1px solid #ede9e9;
}

.chanpinjieshao {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    float: left;
}

.bootom_add_cart {
    width: 100px;
    height: 32px;
    background: #2c9a34;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: right;
    margin-top: 5px;
    cursor: pointer;
}

.right_box_top_box_item {
    width: 120px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    float: left;
    cursor: pointer;
}

.right_box_top_box {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
}

.huanyipi {
    float: left;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
}

.left_goods_price {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f24246;
    float: left;
    margin-left: 2%;
}

.manjian {
    width: 60px;
    height: 20px;
    background: #f24246;
    text-align: center;
    line-height: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: left;
}

.left_goods_item_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.goods_tag {
    width: 50px;
    height: 24px;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fefefe;
}

.left_goods_box {
    width: 100%;
    height: 370px;
    background: #ffffff;
    /* */
    margin-top: 2%;
    cursor: pointer;
}

.tuijian_top_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    float: left;
}

.fengexian {
    width: 2px;
    height: 14px;
    background: #2c9a34;
    float: left;
}

.zhifufangshi {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9a9a9a;
    width: 100%;
}

.pay_buts {
    position: relative;
    width: 150px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    border: 1px solid #2c9a34;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    margin-left: 2%;
    float: left;
    cursor: pointer;
}

.pay_buts1 {
    position: relative;
    width: 150px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    border: 1px solid #2c9a34;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    margin-left: 2%;
    float: left;
    cursor: pointer;
    background: #2c9a34;
    color: #fff;
}

.left_goods_box:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    transform: translateY(-5px);
    transition: all 1s;
}

.number_box {
    width: 70px;
    height: 51px;
    float: left;
}

.tips_bottom {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9a9a9a;
    line-height: 30px;
    margin-top: 10px;
}

.baozhuang {
    height: 24px;
    text-align: center;
    line-height: 24px;
    border: 1px solid #bfbfbf;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 10px;
    float: left;
    margin-top: 10px;
    cursor: pointer;
    padding: 0 10px;
}

.peisong_tips {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}

.fahou_base_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
    margin-top: 5px;
}

.cuxiao_box {
    padding: 0px 2px 0 2px;
    height: 16px;
    background: #f24245;
    text-align: center;
    line-height: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: left;
}

.goods_prcie1 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f24246;
    float: left;
}

.goods_guige1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
}

.goods_guige_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    width: 50%;
    float: left;
}

.goods_pinpai {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    float: left;
}

.goods_title {
    font-size: 24px;
    font-family: Microsoft YaHei UI;
    font-weight: bold;
    color: #343434;
    float: left;
    margin-left: 2%;
}

.gongchangziyin {
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background: #2c9a34;
    float: left;
    margin-top: 10px;
}

.box1 {
    width: 20%;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.xuanzhong {
    border: 1px solid #2c9a34;
    color: #2c9a34;
}

.ant-input-group .ant-input {
    border-color: #2b9a34 !important;
    outline: #2b9a34 !important;
}

.ant-input {
    border-color: #2b9a34 !important;
}

.disable_but {
    background: #ccc;
    color: #fff;
    border: none;
    cursor: not-allowed;
}

.biange12 {
    line-height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    padding: 0 10px;
}

.dibuqiehuan_sty {
    background: #2c9a34;
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/goods_details.vue